const AppMode = {
  Widget: "widget", //show only widget
  Ad: "ad", //show only ad unit
  WidgetAd: "widgetad", //show widget & ad unit
};

export default AppMode;
